import Feature25_morph_left from './Feature25_morph_left'
export default Feature25_morph_left
